export function isArrayEmpty<T>(array: Array<T>): boolean {
    if (array.length === 0) {
      return true
    }

    return false;
}